import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../../../environments/environment';
import { ApiMethodService } from '../../../../tools/services/api/method-api/apiMethod.service';
import { ActionBackOfficeResponse } from '../../../models/api.model';
import {
  DeactivateEvConnectorTypePayload,
  EvConnectorTypeRowDto,
  EvConnectorTypeTableDto,
  EvConnectorTypeTableQuery,
  InsertEvConnectorTypePayload,
  UpdateEvConnectorTypePayload,
} from '../../../models/system-settings/ev-connector-type.model';

@Injectable({ providedIn: 'root' })
export class ApiEvConnectorTypeService {
  private readonly baseUrl = environment.apiPrivateUrl;
  private readonly cookieService = inject(CookieService);
  private readonly apiMethodService = inject(ApiMethodService);

  private get token(): string {
    return this.cookieService.get('token');
  }

  getEvConnectorTypesForTable(query: EvConnectorTypeTableQuery): Observable<EvConnectorTypeTableDto> {
    const params: Record<string, string | number> = {
      page: query.page ?? 1,
      pageSize: query.pageSize ?? 20,
    };
    if (query.search) params['search'] = query.search;

    return this.apiMethodService.request<EvConnectorTypeTableDto>(
      '/SystemSettings/getEvConnectorTypesForTable',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'getEvConnectorTypesForTable',
        token: this.token,
        headerOnly: false,
        params,
      }
    );
  }

  getEvConnectorTypeById(id: number): Observable<EvConnectorTypeRowDto> {
    return this.apiMethodService.request<EvConnectorTypeRowDto>(
      '/SystemSettings/getEvConnectorTypeById',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'getEvConnectorTypeById',
        token: this.token,
        headerOnly: false,
        params: { id },
      }
    );
  }

  insertEvConnectorType(payload: InsertEvConnectorTypePayload): Observable<ActionBackOfficeResponse> {
    return this.apiMethodService.request<ActionBackOfficeResponse>(
      '/SystemSettings/insertEvConnectorType',
      'POST',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'insertEvConnectorType',
        token: this.token,
        headerOnly: false,
        body: payload,
      }
    );
  }

  updateEvConnectorType(payload: UpdateEvConnectorTypePayload): Observable<ActionBackOfficeResponse> {
    return this.apiMethodService.request<ActionBackOfficeResponse>(
      '/SystemSettings/updateEvConnectorType',
      'POST',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'updateEvConnectorType',
        token: this.token,
        headerOnly: false,
        body: payload,
      }
    );
  }

  deactivateEvConnectorType(payload: DeactivateEvConnectorTypePayload): Observable<ActionBackOfficeResponse> {
    return this.apiMethodService.request<ActionBackOfficeResponse>(
      '/SystemSettings/deactivateEvConnectorType',
      'POST',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'deactivateEvConnectorType',
        token: this.token,
        headerOnly: false,
        body: payload,
      }
    );
  }
}
